import Login from "~/features/Auth/pages/Login";
import Register from "~/features/Auth/pages/Register";
import VerifyEmail from "~/features/Auth/pages/VerifyEmail";
import PrivacyPolicy from "~/features/Legal/pages/PrivacyPolicy";
import Terms from "~/features/Legal/pages/Terms";
import {EmptyLayout} from "~/layout";

export const publicRoutes = [
	{ path: "/login", component: Login, layout: EmptyLayout },
	{ path: "/register", component: Register, layout: EmptyLayout },
	// Đích link xác minh email từ hộp thư (?uid&token) — không cần đăng nhập.
	{ path: "/verify-email", component: VerifyEmail, layout: EmptyLayout },
	// Trang pháp lý công khai — Google OAuth verification yêu cầu truy cập không cần đăng nhập.
	{ path: "/privacy-policy", component: PrivacyPolicy, layout: EmptyLayout },
	{ path: "/terms", component: Terms, layout: EmptyLayout },
];